<script lang="ts">
	import IconAction from '$lib/components/IconAction.svelte';
	import { snackbar } from '$lib/stores/snackbar';
	import { t } from 'svelte-i18n';
	import { followOperation, unfollowOperation } from '../services/api/operations';
	import { signInUpModalStore } from '../stores/signInUpModal';
	import { page } from '$app/stores';

	export let follows = false;
	export let operationId: string = null;
	$: tooltipTitle = follows ? $t('followProject.unfollow') : $t('followProject.follow');
	let tooltipPosition = 'top';

	let iconAction = async (operationId: string) => {
		if ($page.data.user) {
			try {
				if (follows) {
					await unfollowOperation(operationId);
				} else {
					await followOperation(operationId);
				}
				follows = !follows;
				let snackbarMessage: string = follows
					? $t('followProject.followConfirmation')
					: $t('followProject.unfollowConfirmation');
				snackbar.open({ message: snackbarMessage });
			} catch (e) {
				snackbar.danger($t('feedback.unavailable'));
				throw e;
			}
		} else {
			signInUpModalStore.open();
		}
	};
</script>

<IconAction
	iconName="favorite"
	on:click={(e) => {
		e.preventDefault(); //Stop la naviguation
		e.stopPropagation(); //Stop l'événement
		iconAction(operationId);
	}}
	{tooltipTitle}
	{tooltipPosition}
	active={follows}
/>
